import { Button } from "@mui/material";
import useCustomContractWrite from "../../Hooks/useCustomContractWrite";
import Loader from "../Loader/Loader";
import { useAccount, useToken } from "wagmi";
import useCustomContractRead from "../../Hooks/useCustomContractRead";
import convertWeiToEther from "../../Utils/convertWeiToEther";
import { useEffect } from "react";
import convertEtherToWei from "../../Utils/convertEtherToWei";
import IUniswapv2Pair from "../../Config/IUniswapv2Pair.json";
import BigNumber from "bignumber.js";

import erc20ABI from "../../../src/Config/erc20ABI.json"

// import AlertMsg from "../AlertMsg/AlertMsg";
const ApproveButton = ({
  tokenAddress,
  spenderAddress,
  setIsApprovedERC20,
  ButtonName,
  spendAmount,
  isLpToken,
  color,
}) => {
  const { address } = useAccount();
  const { data: TokenInfo } = useToken({
    address: tokenAddress,
  });

  const {
    executeWrite: approveContractWrite,
    isLoading: isLoadingApprove,
    isSuccess: isSuccessApprove,
    isError: isErrorApprove,
    error: errorApprove,
    txHash: approveWaitForTransaction,
  } = useCustomContractWrite({
    address: tokenAddress,
    abi: !isLpToken ? erc20ABI : IUniswapv2Pair,
    functionName: "approve",
    args: [
      spenderAddress,
      Number?.(spendAmount) > 0
        ? convertEtherToWei?.(spendAmount, TokenInfo?.decimals)
        : convertEtherToWei?.(
            new BigNumber(
              (Number.MAX_SAFE_INTEGER ** 1.3)?.toString()
            )?.toString(),
            TokenInfo?.decimals
          ),
    ],
    // isEnabled: address !== undefined,
  });


  useEffect(() => {

    // console.log("approveWaitForTransaction", approveWaitForTransaction);
    // console.log("isSuccessApprove", isSuccessApprove);
    if (
      approveWaitForTransaction ||
      isSuccessApprove
    ) {
      // console.log("txComplete");
      setIsApprovedERC20(true);
    }
  }, [
    approveWaitForTransaction,
    approveWaitForTransaction,
    address,
    isSuccessApprove
  ]);

  return (
    <>
      {/* {approveContractWrite?.isError && <AlertMsg/>} */}
      <Button
        disabled={
          !isLoadingApprove &&
          !approveWaitForTransaction 
            ? false
            : true
        }
        sx={{
          gap: "6px !important",
          width: "100% !important",
          color: `${color === "white" ? color : "black"}`,
          // border: "1px solid white",
          padding:"10px 10px",
          borderRadius: "10px",
          fontFamily:"var(--font-pop)",
          fontWeight:"600",
          fontSize:"16px",
          backgroundColor:"var(--main-color)"
        }}
        // startIcon={approveWaitForTransaction.isSuccess? <CheckIcon sx={{ color: "#eee", fontSize: "10px" }} />:null}
        type="button"
        onClick={async () => {
          try {
            // console.log("isLoading", isLoadingApprove);
            await approveContractWrite();
            // console.log("hmm", approveWaitForTransaction, isSuccessApprove, isLoadingApprove, isSuccessApprove);
            
            if (
              approveWaitForTransaction ||
              isSuccessApprove
            ) {
              // console.log("txComplete");
              setIsApprovedERC20(true);
            }
          } catch (error) {
            // //console.log(error, "error");
          }
        }}
         className="btn1"
      >
        {isLoadingApprove ? (
          <Loader color="#423A2A" />
        ) : null}
        {ButtonName ? <>{ButtonName}</> : "Approve"}
      </Button>
    </>
  );
};

export default ApproveButton;
